import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Icon, Popover, Text, useTheme } from '@Sage/hoi-poi-ui';
import styles from './styles.FilterTitle';

const useStyles = createUseStyles(styles, 'FilterTitle');

const FilterTitle = memo(({ label, filterTooltip }) => {
    const classes = useStyles();
    const theme = useTheme();

    const titleElement = (
        <Text type="subtitle" medium color={theme.colors.textLight.secondary}>
            {label}
        </Text>
    );

    if (!filterTooltip) return titleElement;

    return (
        <span className={classes.root}>
            {titleElement}
            <Popover
                trigger={['hover']}
                placement="top"
                content={
                    <div className={classes.popoverContent}>
                        {filterTooltip.title && (
                            <Text type="subtitle" medium>
                                {filterTooltip.title}
                            </Text>
                        )}
                        {filterTooltip.description && (
                            <Text type="caption" color={theme.colors.textLight.secondary}>
                                {filterTooltip.description}
                            </Text>
                        )}
                        {typeof filterTooltip === 'string' && (
                            <Text type="caption">{filterTooltip}</Text>
                        )}
                    </div>
                }
            >
                <span onClick={(e) => e.stopPropagation()}>
                    <Icon name={filterTooltip.icon || 'info'} />
                </span>
            </Popover>
        </span>
    );
});

FilterTitle.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    filterTooltip: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            title: PropTypes.string,
            description: PropTypes.string,
            icon: PropTypes.string,
        }),
    ]),
};

export default FilterTitle;
